"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MonthSelector = exports.CustomSelect = void 0;
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var date_utils_1 = require("../../date-utils");
var MonthIncrementDecrementButton = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  &:hover {\n    text-decoration: underline;\n    cursor: pointer;\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  &:hover {\n    text-decoration: underline;\n    cursor: pointer;\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.coloredText;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.textHighlight;
});
var MonthSelectorContent = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 0.8em 0px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    justify-content: space-between;\n    padding: 0 8vw;\n  }\n"], ["\n  margin: 0.8em 0px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  @media (max-width: 600px) {\n    justify-content: space-between;\n    padding: 0 8vw;\n  }\n"])));
exports.CustomSelect = styled_components_1.default.select(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 1.2rem;\n"], ["\n  font-size: 1.2rem;\n"])));
function MonthSelector(_a) {
    var year = _a.year, month = _a.month, onChange = _a.onChange;
    return (React.createElement(MonthSelectorContent, null,
        React.createElement(MonthIncrementDecrementButton, { onClick: function () {
                var _a = __read(getYearMonth(year, month, -1), 2), effectiveYear = _a[0], effectiveMonth = _a[1];
                onChange(effectiveYear, effectiveMonth);
            }, tabIndex: 0 }, "<<\u00A0\u00A0"),
        React.createElement(exports.CustomSelect, { value: month, onChange: function (v) { return onChange(year, +v.target.value); } }, [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(function (m) { return (React.createElement("option", { key: m, value: m }, (0, date_utils_1.getMonthName)(m))); })),
        React.createElement(exports.CustomSelect, { value: year, onChange: function (v) { return onChange(+v.target.value, month); } }, (0, date_utils_1.getYearsPlusMinus)().map(function (y) { return (React.createElement("option", { key: y, value: y }, y)); })),
        React.createElement(MonthIncrementDecrementButton, { onClick: function () {
                var _a = __read(getYearMonth(year, month, +1), 2), effectiveYear = _a[0], effectiveMonth = _a[1];
                onChange(effectiveYear, effectiveMonth);
            }, tabIndex: 0 }, "\u00A0>>\u00A0")));
}
exports.MonthSelector = MonthSelector;
function getYearMonth(year, month, change) {
    var date = new Date(year, month - 1);
    date.setMonth(date.getMonth() + change);
    return [date.getFullYear(), date.getMonth() + 1];
}
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=month-selector.js.map